export default __webpack_public_path__ + "static/media/speaker.3b9043ca.svg";